import React from 'react'

const UpcomingIncomeRecertifications = () => {
  return (
    <div className='UpcomingIncomeRecertifications'>
       <hr />
       <p>There are no upcoming income certifications at this time.</p>
    </div>
  )
}

export default UpcomingIncomeRecertifications